import { useState } from 'react';
import { EPerPages, ISortOptions } from 'models/table';
import { getApplicationRequest, getApplications } from 'requests/application';
import { IApplication } from 'models/application';
import { IPaginator } from 'models/paginator';

export const useMyApplication = () => {
  const [applications, setApplications] = useState<IApplication[]>([]);
  const [paginator, setPaginator] = useState<IPaginator | null>(null);
  const [application, setApplication] = useState<IApplication | null>(null);
  const getMyApplication = async (
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    sort?: ISortOptions | null,
  ) => {
    const applicationData = await getApplications(currentPage, perPage, sort);

    if (applicationData) {
      const { content, ...paginatorData } = applicationData;
      setApplications(content);
      setPaginator(paginatorData);
    } else {
      setApplications([]);
      setPaginator(null);
    }
  };

  const getApplicationDetails = async (id: string) => {
    const response = await getApplicationRequest(id);

    if (response) {
      setApplication(response);
    } else {
      setApplication(null);
    }
  };

  return { applications, paginator, getMyApplication, getApplicationDetails, application };
};
